<template>
  <ul class="rm-survey-options">
    <li v-for="option in question.options" :key="option.code">
      <button
        type="button"
        class="rm-survey-options__item"
        :class="{
          'rm-survey-options__item--selected': selected.includes(option.code)
        }"
        :role="isMultiple ? 'checkbox' : 'radio'"
        :aria-checked="selected.includes(option.code)"
        @click="emit('select', option.code)"
      >
        <span
          class="rm-survey-options__mark"
          :class="{ 'rm-survey-options__mark--square': isMultiple }"
        />
        {{ option.label }}
      </button>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { RmSurveyQuestion } from '@/utils/realtime-transfer/rmSurvey'

const props = defineProps<{
  question: RmSurveyQuestion
  selected: string[]
}>()
const emit = defineEmits<{ (e: 'select', code: string): void }>()

const isMultiple = computed(() => props.question.answerType === 'multiple')
</script>

<style scoped lang="scss">
$green: #0f9934;

.rm-survey-options {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  margin: 1.4rem 0 0;
  padding: 0;
  list-style: none;
}

.rm-survey-options__item {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  color: #2b2b2b;
  text-align: left;
  background: #fff;
  border: 2px solid #e6e6e6;
  border-radius: 0.6rem;
  cursor: pointer;
}

.rm-survey-options__item--selected {
  background: #f0f4ee;
  border-color: $green;
}

.rm-survey-options__mark {
  flex-shrink: 0;
  box-sizing: border-box;
  width: 1.05rem;
  height: 1.05rem;
  border: 1.5px solid #555;
  border-radius: 50%;

  .rm-survey-options__item--selected & {
    background: $green;
    border-color: $green;
    box-shadow: inset 0 0 0 3px #fff;
  }
}

.rm-survey-options__mark--square {
  border-radius: 0.2rem;
}
</style>
